"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {},
  data: function data() {
    return {
      action_type: 'set',
      requestdomain: [''],
      wsrequestdomain: [''],
      uploaddomain: [''],
      downloaddomain: [''],
      webviewdomain: [''],
      type: 0
    };
  },
  mounted: function mounted() {
    this.type = this.$route.query.type || 1;
    if (this.$route.query.app_id) this.getInfo();
  },
  methods: {
    /**
       * 获取信息
       */
    getInfo: function getInfo() {
      var _this = this;
      var url = 'WxOpen/modifyServerDomain';
      if (this.type == 2) url = 'WxOpen/setWebViewDomain';
      this.$post(url, {
        wxmini_appid: this.$route.query.app_id,
        action_type: 'get'
      }).then(function (res) {
        if (_this.type == 2) _this.webviewdomain = res.webviewdomain.length > 0 ? res.webviewdomain : [''];
        if (_this.type == 1) {
          _this.downloaddomain = res.downloaddomain.length > 0 ? res.downloaddomain : [''];
          _this.requestdomain = res.requestdomain.length > 0 ? res.requestdomain : [''];
          _this.uploaddomain = res.uploaddomain.length > 0 ? res.uploaddomain : [''];
          _this.wsrequestdomain = res.wsrequestdomain.length > 0 ? res.wsrequestdomain : [''];
        }
      });
    },
    /**
       * 提交服务域名
       */
    seversDomain: function seversDomain() {
      var _this2 = this;
      var url = 'WxOpen/modifyServerDomain';
      var params = {};
      params.wxmini_appid = this.$route.query.app_id;
      params.action_type = this.action_type;
      params.domains = {
        action: this.action_type,
        requestdomain: JSON.parse(JSON.stringify(this.requestdomain)),
        wsrequestdomain: JSON.parse(JSON.stringify(this.wsrequestdomain)),
        uploaddomain: JSON.parse(JSON.stringify(this.uploaddomain)),
        downloaddomain: JSON.parse(JSON.stringify(this.downloaddomain))
      };
      params.domains = JSON.stringify(params.domains);
      this.$post(url, params).then(function (res) {
        _this2.$message({
          message: '提交成功',
          type: 'success'
        });
        if (_this2.checkRoles(['terminal'])) {
          _this2.$router.push({
            path: '/wx/index'
          });
          return;
        }
        _this2.$router.push({
          path: '/setting/index'
        });
      });
    },
    /**
       * 提交业务域名
       */
    webDomain: function webDomain() {
      var _this3 = this;
      var url = 'WxOpen/setWebViewDomain';
      var params = {};
      params.wxmini_appid = this.$route.query.app_id;
      params.action_type = this.action_type;
      params.domains = {
        action: this.action_type,
        webviewdomain: JSON.parse(JSON.stringify(this.webviewdomain))
      };
      params.domains = JSON.stringify(params.domains);
      this.$post(url, params).then(function (res) {
        _this3.$message({
          message: '提交成功',
          type: 'success'
        });
        if (_this3.checkRoles(['terminal'])) {
          _this3.$router.push({
            path: '/wx/index'
          });
          return;
        }
        _this3.$router.push({
          path: '/setting/index'
        });
      });
    },
    /**
       * 获取授权url
       */
    getAuthUrl: function getAuthUrl() {
      this.$post('WxOpen/AuthorizerUrl', {}).then(function (res) {
        window.open(res.url);
      });
    },
    /**
       * 添加删除input
       */
    addInput: function addInput(type, params) {
      var self = this;
      switch (type) {
        case 1:
          self[params.name].push('');
          break;
        case 2:
          self[params.name].splice(params.key, 1);
          break;
      }
    }
  }
};